const atom = require('recoil').atom;

module.exports = {
  specialtyState: atom({
    key: 'specialtyState',
    default: null
  }),
  intelligenceChatIdState: atom({
    key: 'intelligenceChatIdState',
    default: null
  }),
  intelligenceChatMessageIdState: atom({
    key: 'intelligenceChatMessageIdState',
    default: null
  }),
  promptListState: atom({
    key: 'promptListState',
    default: []
  }),
  activePromptConversationsState: atom({
    key: 'activePromptConversationsState',
    default: []
  }),
  myScribeAILoadingState: atom({
    key: 'myScribeAILoadingState',
    default: false
  }),
  myScribeAcknowledged: atom({
    key: 'myScribeAcknowledged',
    default: false
  }),
  myScribeAutoMapSelectedNoteTypeState: atom({
    key: 'myScribeAutoMapSelectedNoteTypeState',
    default: null
  }),
  myScribeAutoMapActivePromptIdState: atom({
    key: 'myScribeAutoMapActivePromptIdState',
    default: null
  }),
  isAIGeneratingState: atom({
    key: 'isAIGeneratingState',
    default: false
  }),
  enhanceNoteLoadingState: atom({
    key: 'enhanceNoteLoadingState',
    default: []
  })
};
